const config = {
  sideBySide: {
    view: 'sideBySide',
    text: 'Side by Side',
    url: '/appointments',
    className: 'c-form-input-group__item',
  },
  agendaWeek: {
    view: 'agendaWeek',
    text: 'Week',
    url: '/appointments/week',
    className: 'c-form-input-group__item',
  },
  list: {
    view: 'list',
    text: 'List',
    url: '/appointments/list',
    className: 'c-form-input-group__item',
  },
};

export default config;
